var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M5.172 12c0-.78.13-1.527.36-2.228L1.489 6.684A11.994 11.994 0 0 0 .256 12c0 1.91.444 3.713 1.23 5.312l4.043-3.094A7.099 7.099 0 0 1 5.172 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M12.273 4.91c1.693 0 3.223.6 4.425 1.58L20.193 3c-2.13-1.855-4.861-3-7.92-3-4.749 0-8.83 2.716-10.785 6.684l4.044 3.088a7.082 7.082 0 0 1 6.741-4.863Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M12.273 19.091a7.082 7.082 0 0 1-6.74-4.863l-4.045 3.088A11.98 11.98 0 0 0 12.273 24c2.931 0 5.73-1.04 7.83-2.99l-3.84-2.969c-1.082.683-2.446 1.05-3.99 1.05Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M23.744 12c0-.709-.11-1.473-.273-2.182H12.273v4.637h6.446c-.323 1.58-1.2 2.796-2.455 3.586l3.839 2.968c2.206-2.047 3.64-5.098 3.64-9.009Z",
    clipRule: "evenodd"
  })));
};
export default SvgGoogle;